import React, { FC } from 'react';

import toast, { Toast } from 'react-hot-toast';
import { IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Close } from '@mui/icons-material';

import { NotificationPriorities, NotificationsType } from '@pharmaplan/common';

import { ReactComponent as Priority } from '../../assets/svg/priorityNotification.svg';

import useNotification from '../../hooks/useNotification';
import genericClasses from '../../theme/GenericClasses';

import styles from './styles';

interface IToastNotification {
  data: {
    title: string;
    body: string;
    notificationType: NotificationsType;
    bookingId: string;
    notificationId: string;
    priority: NotificationPriorities;
  };
  toastParams: Toast;
}

const ToastNotification: FC<IToastNotification> = ({ toastParams, data }) => {
  const { body, priority } = data ?? {};

  const isPriority = priority === NotificationPriorities.critical;

  const handleDismiss = (
    e?: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e?.stopPropagation();
    toast.dismiss(toastParams.id);
  };

  const { handleActions } = useNotification({
    closeNotification: handleDismiss,
  });

  return (
    <Box
      onClick={() =>
        handleActions(data as any)}
      sx={[genericClasses.flex, styles.container]}
    >
      <Box sx={styles.content}>
        {isPriority && (
          <Box sx={styles.criticalIcon}>
            <Priority />
          </Box>
        )}
        <Typography sx={styles.body}>{body}</Typography>
      </Box>
      <Box>
        <IconButton onClick={handleDismiss}>
          <Close />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ToastNotification;
